export const HTML_TEXTFIELD_CLASS = "ggsTextField";

export function insertInputFieldElementCSS() {
    /*
     * Shared CSS for native `<input>`/`<textarea>` elements used for user input
     */
    const styleNode = document.createElement(`style`);
    const cssText = `
            textarea.${HTML_TEXTFIELD_CLASS},
            textarea.${HTML_TEXTFIELD_CLASS}:focus,
            input.${HTML_TEXTFIELD_CLASS},
            input.${HTML_TEXTFIELD_CLASS}:focus {
                outline: none;
                box-shadow: none;
                border: none;
                background-color: transparent;
                display: none;
                position: absolute;
                overflow: hidden;
            }
    
            textarea.${HTML_TEXTFIELD_CLASS} {
                resize: none;
            }
    
            @-webkit-keyframes autofill {
                to {
                    color: #000000;
                    background: transparent;
                }
            }
    
            input.${HTML_TEXTFIELD_CLASS}:-webkit-autofill,
            input.${HTML_TEXTFIELD_CLASS}:-webkit-autofill:hover,
            input.${HTML_TEXTFIELD_CLASS}:-webkit-autofill:focus,
            input.${HTML_TEXTFIELD_CLASS}:-webkit-autofill:active {
                -webkit-animation-name: autofill;
                -webkit-animation-fill-mode: both;
            }
    `;
    styleNode.appendChild(document.createTextNode(cssText));
    document.head.appendChild(styleNode);
}
